import { usePaymentFailedNotice } from 'presentation/main/GlobalNotice/PaymentFailedNotice'
import { useSubscriptionNotice } from 'presentation/main/GlobalNotice/SubscriptionNotice'
import { useExpiringCardNotice } from './ExpiringCardNotice'

export const useGlobalNotice = () => {
  useSubscriptionNotice()
  useExpiringCardNotice()
  usePaymentFailedNotice()
}
